import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import ChooseRole from "@/pages/ChooseRole";
import FamilyAccept from "@/pages/FamilyAccept";
import FamilyView from "@/pages/FamilyView";
import EmergencyButton from "@/components/EmergencyButton";
import Earnings from "@/pages/Earnings";
import VerifyCertificate from "@/pages/VerifyCertificate";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import AiAssistant from "@/components/AiAssistant";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import PostRequest from "@/pages/PostRequest";
import RequestDetail from "@/pages/RequestDetail";
import Helpers from "@/pages/Helpers";
import HelperProfile from "@/pages/HelperProfile";
import Messages from "@/pages/Messages";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Profile from "@/pages/Profile";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return <div className="min-h-screen flex items-center justify-center text-lg">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "pending") return <Navigate to="/choose-role" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function Shell() {
  const { user } = useAuth();
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/family/accept" element={<FamilyAccept />} />
        <Route path="/family" element={<FamilyView />} />
        <Route path="/verify/:code" element={<VerifyCertificate />} />
        <Route path="/earnings" element={<Protected roles={["helper"]}><Earnings /></Protected>} />
        <Route path="/choose-role" element={user ? <ChooseRole /> : <Navigate to="/login" replace />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/helpers" element={<Helpers />} />
        <Route path="/helpers/:id" element={<HelperProfile />} />
        <Route path="/requests/:id" element={<RequestDetail />} />
        <Route path="/post" element={<Protected roles={["seeker", "admin"]}><PostRequest /></Protected>} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/messages" element={<Protected><Messages /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {user && user.role !== "pending" && <AiAssistant />}
      <EmergencyButton />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
